import { Link } from 'react-router-dom';
import { useAccount } from '../../features/onboarding/useAccount';
import { PLAN_LABEL, upgradePath } from './planLabels';
import { usePlanName } from './usePlan';

/**
 * A thin line over every screen while the active brand is locked: past the
 * plan's brand allowance, readable, every write refused with a 402. The way
 * out is an upgrade or deleting a brand (settings), and the banner says both.
 */
export function LockedBrandBanner() {
  const { business } = useAccount();
  const planName = usePlanName();
  if (!business?.locked) return null;

  return (
    <p className="locked-brand-banner" role="status">
      <span>This brand is locked on {planName ? PLAN_LABEL[planName] : 'your plan'}</span>
      <span aria-hidden="true">·</span>
      <span>
        <Link to={upgradePath(planName === 'studio' ? null : 'studio')}>Upgrade</Link> or{' '}
        <Link to="/settings">delete a brand</Link>
      </span>
    </p>
  );
}
